/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
const loginUrl = 'https://login.flyme.cn/vCodeLogin?sid=unionlogin&service=store&autodirct=true&useruri=http://store.meizu.com/member/login.htm?useruri=';
const getLoginURI = pid => {
  return `${loginUrl}${encodeURIComponent(encodeURIComponent(`${window.location.protocol}//mcycle.meizu.com/view/appraisal/${pid}`))}`
};

export default getLoginURI;



// WEBPACK FOOTER //
// ./src/utils/getLoginURI.js